import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Courses from './components/Courses';
import About from './components/About';
import Products from './components/Products';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import PrivacyPolicy from './components/PrivacyPolicy';
import DetailedProductPinkOnions from './components/DetailedProductPinkOnions';
import DetailedProductRedOnions from './components/DetailedProductRedOnions';
import DetailedProductwhiteOnions from './components/DetailedProductwhiteOnions';
import DetailedProductGarlic from './components/DetailedProductGarlic';
import DetailedFriedOnions from './components/DetailedFriedOnions';
import DetailedvegetabelAndSpices from './components/DetailedVegetableAndSpices';
import AiAssistant from './components/AiAssistant';

const theme = createTheme({
  typography: {
    fontFamily: '"Lora", serif', // Apply Lora font globally
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/products" element={<Products />} />
          <Route path="/detailed-products-pink-onion" element={<DetailedProductPinkOnions />} />
          <Route path="/detailed-products-red-onion" element={<DetailedProductRedOnions />} />
          <Route path="/detailed-products-white-onion" element={<DetailedProductwhiteOnions />} />
          <Route path="/detailed-products-garlic" element={<DetailedProductGarlic />} />
          <Route path="/detailed-products-fried-onions" element={<DetailedFriedOnions />} />
          <Route path="/detailed-products-vegetable-powders-and-spices" element={<DetailedvegetabelAndSpices />} />


          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/private-ai" element={<AiAssistant />} />

        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
};

export default App;
